/**
 * Image upload queue processor.
 *
 * Delegates to ImageUploadService for the actual queue processing logic.
 * This file exists as a thin wrapper so that callers (useSync.ts) don't need
 * to know about the service singleton.
 */

import { persist } from './sqlite'
import { getImageUploadService } from './services/imageUploadServiceInstance'
import { useAuthStore } from '../store/auth'

/**
 * Process all pending image uploads from the queue.
 * Should be called during sync cycles / on reconnect.
 */
export async function processImageUploadQueue(): Promise<void> {
  // Local mode: no session, so every upload attempt would 401 and burn the
  // 3-retry budget. The service enforces the same gate; this is the cheap
  // early exit. Uploads wait in the queue until an account exists.
  if (!useAuthStore.getState().user) return
  const service = getImageUploadService()
  await service.processQueue()

  // Persist DB changes after processing the queue
  await persist()
}
